<template>
  <section class="p-2">
    <v-card>
      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-row class="px-5">
            <v-col cols="12" lg="3" sm="6" xs="12">
              <v-autocomplete
                v-model="selectedPayment"
                class="rounded"
                dense
                outlined
                item-text="txt"
                item-value="val"
                :items="paymentMethods"
                placeholder="Payment Modes"
              ></v-autocomplete>
            </v-col>
            <v-btn
              depressed
              small
              class="text-capitalize me-2 ms-2 mt-1 text-decoration-none"
              color="primary"
              @click="getServiceChargeSummary()"
              >Get results</v-btn
            >
          </v-row>
        </v-card>
      </v-card-text>
      <v-data-table
        :headers="dessertHeaders"
        :items="serviceSummary"
        :search="search"
        fixed-header
        height="55vh"
        dense
        item-key="name"
      >
        <template v-slot:item.service_charge="{ item }">
          <div class="d-flex">
            {{ item.service_charge }}
            <div v-if="item.service_charge_type == 'Flat'"></div>
            <div v-else>%</div>
          </div>
        </template>
        <template v-slot:item.send_commission="{ item }">
          <div class="d-flex">
            {{ item.send_commission }}
            <div v-if="item.send_commission_type == 'Flat'"></div>
            <div v-else>%</div>
          </div>
        </template>
        <template v-slot:item.pay_commission="{ item }">
          <div class="d-flex">
            {{ item.pay_commission }}
            <div v-if="item.pay_commission_type == 'Flat'"></div>
            <div v-else>%</div>
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-icon
              small
              title="Edit"
              color="primary"
              class="mr-2"
              @click="editItem(item)"
            >
              mdi-content-save-edit-outline
            </v-icon>
            <v-icon
              small
              title="Delete"
              color="primary"
              class="mr-2"
              @click="deleteItem(item)"
            >
              mdi-trash-can-outline
            </v-icon>
          </div>
        </template>

        <template v-slot:top>
          <div class="d-flex mt-2">
            <v-btn
              depressed
              small
              class="text-capitalize me-2 ms-2 mt-2 text-decoration-none"
              color="primary"
              @click="openDialog()"
              ><v-icon small>mdi-plus</v-icon>Add</v-btn
            >
            <v-spacer> </v-spacer>
            <v-spacer> </v-spacer>
            <v-btn
              depressed
              @click="downloadExcelsheet"
              color="primary"
              small
              class="me-5 mt-2"
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              class="me-4 mb-3"
              dense
              clearable
            ></v-text-field>
          </div>
        </template>
      </v-data-table>
      <v-dialog persistent v-model="showDialog" width="800">
        <v-card>
          <v-form ref="Addform" v-model="valid">
            <v-toolbar color="#050048" dark flat dense>
              <span>{{ formtitle }} service Charge</span>
              <v-spacer></v-spacer>
              <v-btn depressed icon @click="closeDialog()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="6"
                  ><label class="my-0 labelFontsize required">
                    Channel Partner
                  </label>
                  <v-autocomplete
                    v-model="serviceDetails.send_partner_id"
                    class="rounded"
                    dense
                    outlined
                    :disabled="serviceDetails.id"
                    item-text="txt"
                    item-value="val"
                    :items="senderPartners"
                    :rules="FieldRequired('Partner')"
                    placeholder="Partner"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6"
                  ><label class="my-0 labelFontsize required">
                    Payout Country
                  </label>
                  <v-autocomplete
                    v-model="serviceDetails.country_code"
                    class="rounded"
                    dense
                    outlined
                    placeholder="Payout Country"
                    item-text="txt"
                    item-value="val"
                    :disabled="serviceDetails.id"
                    :items="countryOptions"
                    :rules="FieldRequired('Country')"
                    @input="getPaymentModes(serviceDetails.country_code)"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6"
                  ><label class="my-0 labelFontsize required">
                    Payment Mode
                  </label>
                  <v-autocomplete
                    v-model="serviceDetails.payment_mode"
                    class="rounded"
                    dense
                    outlined
                    item-text="txt"
                    item-value="val"
                    :disabled="serviceDetails.id"
                    :items="method_options"
                    :rules="FieldRequired('Payment Mode')"
                    placeholder="Payment Mode"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6"
                  ><label class="my-0 labelFontsize required"> Currency </label>
                  <v-text-field
                    dense
                    outlined
                    disabled
                    placeholder="Currency"
                    class="rounded"
                    v-model="serviceDetails.currency_code"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <label class="my-0 labelFontsize required">
                    Min. Amount
                  </label>
                  <v-text-field
                    class="rounded"
                    v-model="serviceDetails.min_amount"
                    dense
                    outlined
                    placeholder="Min"
                    type="number"
                    hide-spin-buttons
                    @keydown="filterNumberInput"
                    @input="validateMinNumber(serviceDetails.min_amount)"
                    :rules="[
                      ...FieldNumbRequired('Min. Amount'),
                      ...minAmountRules,
                    ]"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <label class="my-0 labelFontsize required">
                    Max. Amount</label
                  >
                  <v-text-field
                    class="rounded"
                    v-model="serviceDetails.max_amount"
                    dense
                    outlined
                    placeholder="Max"
                    type="number"
                    hide-spin-buttons
                    @keydown="filterNumberInput"
                    @input="validateMaxNumber(serviceDetails.max_amount)"
                    :rules="[
                      ...FieldNumbRequired('Max. Amount'),
                      ...maxAmountRules,
                    ]"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6" class="d-flex">
                  <v-col cols="5 px-0">
                    <label class="my-0 labelFontsize required"
                      >Service Charge Type</label
                    >
                    <v-autocomplete
                      v-model="serviceDetails.service_charge_type"
                      class="rounded"
                      dense
                      outlined
                      item-text="txt"
                      item-value="val"
                      :items="docs_LIST"
                      placeholder="Service Charge Type"
                      @input="serviceCharge(serviceDetails.service_charge_type)"
                      :rules="FieldRequired('Field')"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="7 px-0">
                    <label class="my-0 labelFontsize"></label>
                    <v-text-field
                      class="rounded"
                      v-model="serviceDetails.service_charge"
                      dense
                      outlined
                      placeholder=""
                      type="number"
                      hide-spin-buttons
                      @keydown="filterNumberInput"
                      :rules="FieldNumbRequired('Service Charge')"
                    >
                    </v-text-field>
                  </v-col>
                </v-col>
                <v-col cols="6" class="d-flex">
                  <v-col cols="5 px-0">
                    <label class="my-0 labelFontsize required"
                      >Channel Partner Commission</label
                    >
                    <v-autocomplete
                      v-model="serviceDetails.send_commission_type"
                      class="rounded"
                      dense
                      outlined
                      item-text="txt"
                      item-value="val"
                      :items="docs_LIST"
                      :disabled="disableChargeType"
                      placeholder="Commision Type"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="7 px-0">
                    <label class="my-0 labelFontsize"></label>
                    <v-text-field
                      class="rounded"
                      v-model="serviceDetails.send_commission"
                      dense
                      outlined
                      placeholder=""
                      type="number"
                      hide-spin-buttons
                      @keydown="filterNumberInput"
                      :rules="FieldNumbRequired('Channel Partner Commission')"
                    >
                    </v-text-field>
                  </v-col>
                </v-col>
                <v-col cols="6" class="d-flex">
                  <v-col cols="5 px-0">
                    <label class="my-0 labelFontsize required"
                      >Payout Partner Fee</label
                    >
                    <v-autocomplete
                      v-model="serviceDetails.pay_commission_type"
                      class="rounded"
                      dense
                      outlined
                      :disabled="disableChargeType"
                      item-text="txt"
                      item-value="val"
                      :items="docs_LIST"
                      placeholder="Commision Type"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="7 px-0">
                    <label class="my-0 labelFontsize"></label>
                    <v-text-field
                      class="rounded"
                      v-model="serviceDetails.pay_commission"
                      dense
                      outlined
                      placeholder=""
                      type="number"
                      hide-spin-buttons
                      @keydown="filterNumberInput"
                      :rules="FieldNumbRequired('Payout Partner Fee')"
                    >
                    </v-text-field>
                  </v-col>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="pa-0 mb-0"></v-divider>
            <v-card-actions class="ma-0 pt-0">
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                small
                class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
                color="primary"
                @click="submitData()"
                ><v-icon small>mdi-content-save-plus-outline</v-icon>Submit
              </v-btn>
              <v-btn
                depressed
                small
                class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
                color="primary"
                outlined
                @click="closeDialog()"
                ><v-icon small>mdi-close</v-icon>cancel
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <!-- delete dialog -->
      <v-dialog persistent v-model="dialogDelete" width="500">
        <v-card>
          <v-card-title class="border border-bottom">Delete</v-card-title>
          <v-card-text class="h5 py-3"
            >Are you sure you want to delete?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="deleteItemConfirm"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="(dialogDelete = false), (deleteId = null)"
              ><v-icon>mdi-close</v-icon></v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <OverlayPageVue :showOverlay="loader" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import commonService from "@/services/CommonService/commonService.js";
import setupService from "@/services/SetupService/setupService.js";
import partnerService from "@/services/partnerService/partnerService.js";
import { FieldRequired, FieldNumbRequired } from "@/utils/validation.js";
import { filterNumberInput } from "@/utils/contactNumber/formatNumber.js";
import alerts from "@/mixins/alerts";
export default {
  mixins: [alerts],
  name: "Master Bank Summary",
  data() {
    return {
      FieldRequired,
      FieldNumbRequired,
      filterNumberInput,
      // expanded: [],
      search: "",
      dialogDelete: false,
      deleteId: null,
      loader: false,
      showDialog: false,
      disableChargeType: false,
      valid: true,
      editedIndex: -1,
      selectedPayment: "B",
      countryOptions: [],
      method_options: [],
      docs_LIST: [],
      paymentMethods: [],
      senderPartners: [],
      minAmountRules: [],
      maxAmountRules: [],
      dropdown: {
        country_objs: [],
      },
      dessertHeaders: [
        {
          text: "Id",
          sortable: false,
          value: "id",
        },
        {
          text: "Channel Partner",
          value: "send_partner_name",
          sortable: false,
        },
        { text: "Payout Country", value: "country_name", sortable: false },
        { text: "Payment Mode", value: "payment_mode", sortable: false },
        { text: "Currency", value: "currency", sortable: false },
        { text: "Min. Amt", value: "min_amount", sortable: false },
        { text: "Max. Amt", value: "max_amount", sortable: false },
        { text: "Service Charge", value: "service_charge", sortable: false },
        {
          text: "Channel Partner Commission",
          value: "send_commission",
          sortable: false,
        },
        {
          text: "Payout Partner Fee",
          value: "pay_commission",
          sortable: false,
        },
        { text: "Action", value: "action", sortable: false },
      ],
      serviceSummary: [],
      serviceDetails: {
        send_partner_id: 0,
        payment_mode: "",
        country_code: "",
        charge_level: "CW",
        min_amount: 0,
        max_amount: 0,
        service_charge_type: "F",
        service_charge: 0,
        send_commission_type: "P",
        send_commission: 0,
        pay_commission_type: "P",
        pay_commission: 0,
        currency_code: "",
        is_active: true,
        txn_type: "BUS",
      },
    };
  },
  components: {
    OverlayPageVue,
  },
  watch: {
    "serviceDetails.country_code"(val) {
      this.dropdown.country_objs.map((ele) => {
        if (ele.iso_alpha3 === val) {
          this.serviceDetails.currency_code = ele.currency_code;
        }
      });
    },

    // "serviceDetails.service_charge_type"(val) {
    //   if(val==="P"){
    //     this.disableChargeType = true;
    //     this.serviceDetails.send_commission_type = val;
    //     this.serviceDetails.pay_commission_type = val;
    //   }else {
    //     this.disableChargeType = false;
    //     this.serviceDetails.send_commission_type = val;
    //     this.serviceDetails.pay_commission_type = val;
    //   }
    // },
  },
  mounted() {
    this.getcountryList();
    this.getdocss();
    this.getServicePayments();
    this.getAllSendPartners();
    // if (this.selectedPayment) {
    //   this.getServiceChargeSummary();
    // }
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
  },
  methods: {
    serviceCharge(val) {
      if (val === "P") {
        this.disableChargeType = true;
        this.serviceDetails.send_commission_type = val;
        this.serviceDetails.pay_commission_type = val;
      } else {
        this.disableChargeType = false;
        this.serviceDetails.send_commission_type = val;
        this.serviceDetails.pay_commission_type = val;
      }
    },
    validateMinNumber(val) {
      const minAmount = parseInt(this.serviceDetails.max_amount);
      const maxAmount = parseInt(val);
      if (maxAmount > minAmount && this.serviceDetails.max_amount) {
        this.minAmountRules.push("Min. Amount less than Max. Amount");
      } else {
        this.minAmountRules = [];
        this.maxAmountRules = [];
      }
    },
    validateMaxNumber(val) {
      const maxAmount = parseInt(this.serviceDetails.min_amount);
      const minAmount = parseInt(val);
      if (minAmount < maxAmount && this.serviceDetails.min_amount) {
        this.maxAmountRules.push("Max. Amount greater than Min. Amount");
      } else {
        this.maxAmountRules = [];
        this.minAmountRules = [];
      }
    },
    async getServiceChargeSummary() {
      this.loader = true;
      try {
        const response = await setupService.getServiceChargeData({
          payment_mode: this.selectedPayment,
          charge_level: "CW",
          txn_type: "BUS",
        });
        if (response.data.status_code === 200) {
          this.serviceSummary = response.data.data;
          console.log("service Charge Data", this.serviceSummary);
          this.stoploader();
        } else {
          this.serviceSummary == [];
          this.stoploader();
        }
      } catch (error) {
        this.serviceSummary = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getServiceChargeById(id) {
      this.loader = true;
      try {
        const response = await setupService.getChargeById(id);
        if (response.data.status_code === 200) {
          this.serviceDetails = response.data.data[0];
          this.serviceDetails.send_commission = response.data.data[0]
            .send_commission
            ? response.data.data[0].send_commission
            : 0;
          this.serviceDetails.pay_commission = response.data.data[0]
            .pay_commission
            ? response.data.data[0].pay_commission
            : 0;
          this.getPaymentModes(this.serviceDetails.country_code);
          this.$refs.Addform
            ? this.$refs.Addform.resetValidation()
            : this.$refs.Addform.validate();
          console.log("service Charge Data", this.serviceDetails);
          this.stoploader();
        } else {
          this.stoploader();
        }
      } catch (error) {
        this.stoploader();
        console.error(error);
      }
    },
    async save() {
      try {
        const response = await setupService.addCountryWise(this.serviceDetails);
        if (response.data.status_code === 200) {
          this.showAlertSuccess(response.data.message);
          this.showDialog = false;
          this.getServiceChargeSummary();
        } else {
          this.showAlertError(response.data.message);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async update() {
      try {
        const response = await setupService.updateChargeById(
          this.serviceDetails.id,
          this.serviceDetails,
        );
        if (response.data.status_code === 200) {
          this.showAlertSuccess(response.data.message);
          this.showDialog = false;
          this.getServiceChargeSummary();
        } else {
          this.showAlertError(response.data.message);
        }
      } catch (error) {
        console.error(error);
      }
    },
    deleteItem(item) {
      this.dialogDelete = true;
      this.deleteId = item.id;
    },

    async deleteItemConfirm() {
      try {
        const response = await setupService.deleteServiceCharge(this.deleteId);
        if (response.data.status_code === 200) {
          this.showAlertSuccess(response.data.message);
          this.dialogDelete = false;
          this.getServiceChargeSummary();
        } else {
          this.showAlertError(response.data.message);
          this.dialogDelete = false;
        }
      } catch (error) {
        console.error(error);
        this.dialogDelete = false;
      }
    },
    async getcountryList() {
      this.loader = true;
      try {
        const response = await setupService.getCountrysetupList();
        if (response.status === 200) {
          this.countryOptions = response.data.data.map((i) => {
            return { txt: i.name, val: i.iso_alpha3 };
          });
        }
        this.dropdown.country_objs = response.data.data;
        console.log("countryOptions", this.countryOptions);
        this.stoploader();
      } catch (e) {
        console.error(e);
        this.stoploader();
        this.countryOptions = [];
      }
    },
    async getPaymentModes(country_code) {
      this.loader = true;
      try {
        const response = await setupService.getpaymentmodeBycntry(country_code);
        if (response.data.status_code === 200) {
          this.method_options = [
            ...response.data.data.map((i) => {
              return {
                txt: i.payment_type.payment_mode,
                val: i.payment_type.payment_mode_code,
              };
            }),
          ];
          console.log("countryOptions", this.method_options);
          this.stoploader();
        } else {
          this.method_options == [];
          this.stoploader();
        }
      } catch (error) {
        this.method_options = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getdocss() {
      const code = "STP";
      try {
        const responseData = await commonService.getparameterdropdowns(code);
        if (responseData.data.status_code === 200) {
          this.docs_LIST = responseData.data.data.map((i) => {
            return { txt: i.value, val: i.value_code };
          });
        }
        // else if (responseData.data.status_code == 401) {
        //       this.returnNewToken();
        //       this.getdocss();
        // }
        console.log("docs_LIST", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getServicePayments() {
      const code = "PTY";
      try {
        const responseData = await commonService.getparameterdropdowns(code);
        if (responseData.data.status_code === 200) {
          this.paymentMethods = responseData.data.data.map((i) => {
            return { txt: i.value, val: i.value_code };
          });
        }
        // else if (responseData.data.status_code == 401) {
        //       this.returnNewToken();
        //       this.getdocss();
        // }
        console.log("payments", responseData);
      } catch (e) {
        console.error(e);
      }
    },

    async getAllSendPartners() {
      try {
        const responseData = await partnerService.getAllSenderPartners();
        if (responseData.data.status_code === 200) {
          this.senderPartners = responseData.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });
        }
        // else if (responseData.data.status_code == 401) {
        //       this.returnNewToken();
        //       this.getdocss();
        // }
        console.log("payments", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    submitData() {
      const validate = this.$refs.Addform.validate();
      if (validate) {
        if (this.serviceDetails.id) {
          this.update();
        } else {
          this.save();
        }
      }
    },
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    async downloadExcelsheet() {
      if (this.serviceSummary) {
        this.exportToExcel(
          this.dessertHeaders,
          this.serviceSummary,
          "serviceSummary",
        );
      }
    },

    openDialog() {
      this.showDialog = true;
      this.resetserviceDetailsObj();
      if (this.$refs.Addform) {
        this.$refs.Addform.resetValidation();
      }
    },
    resetserviceDetailsObj() {
      this.serviceDetails = {};
      this.serviceDetails.min_amount = 0;
      this.serviceDetails.max_amount = 0;
      this.serviceDetails.pay_commission = 0;
      this.serviceDetails.send_commission = 0;
      this.serviceDetails.service_charge = 0;
      this.serviceDetails.service_charge_type = "F";
      this.serviceCharge(this.serviceDetails.service_charge_type);
      this.serviceDetails.charge_level = "CW";
      this.serviceDetails.is_active = true;
      this.serviceDetails.txn_type = "BUS";
    },

    editItem(item) {
      this.showDialog = true;
      this.getServiceChargeById(item.id);
      console.log(this.serviceDetails);
    },

    closeDialog() {
      this.showDialog = false;
      this.$refs.Addform.resetValidation();
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";

.width-anchor {
  width: 200px !important;
}

.required:after {
  content: " *";
  color: red;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
</style>
